import { useContext, useEffect, useState } from "react"

import { useLocalSearchParams } from "expo-router"

import { ClientCollection, User } from "wealthmode-frontend/backend"
import { Icon, Text } from "wealthmode-frontend/gluestack/ui"
import { AsteriskIcon, BadgeQuestionMarkIcon, type LucideIcon } from "wealthmode-frontend/icons"

import { RawDataTable } from "@/components"
import { BackendContext } from "@/context"
import { GoogleIcon } from "@/lib/BrandIcons"

export default function Accounts() {
  const { client_id } = useLocalSearchParams<{ client_id: string }>()
  const backend = useContext(BackendContext)

  const [loading, setLoading] = useState(true)
  const [users, setUsers] = useState<User[]>([])

  useEffect(() => {
    async function go() {
      var clients = backend.collection("clients") as ClientCollection
      var client = clients.model(client_id)
      await client.fetch()

      var users = client.embed("users") as User[]

      setUsers(users)
      setLoading(false)
    }

    go().catch((err) => {
      console.error("Error: " + err)
      throw err
    })
  }, [backend, client_id])

  return (
    <RawDataTable
      title={"Users"}
      loading={loading}
      rows={users}
      header={[
        { id: "id", title: "ID", shrink: true },
        { id: "name", title: "Name" },
        { id: "email", title: "Email" },
        { id: "provider", title: "Auth Provider" },
      ]}
      render={(model: User, field: string) => {
        switch (field) {
          case "provider":
            let icon: LucideIcon = BadgeQuestionMarkIcon

            if (model.attributes.provider == "google-oauth2") {
              icon = GoogleIcon
            } else if (model.attributes.provider == "password") {
              icon = AsteriskIcon
            }

            return (
              <Text className="text-foreground-secondary">
                <Icon
                  as={icon}
                  className="inline shrink-0 text-foreground-tertiary h-8 w-8"
                />
              </Text>
            )
        }
        return <Text className="text-foreground-secondary">{model.get(field)}</Text>
      }}
    />
  )
}
